import { render, staticRenderFns } from "./index.vue?vue&type=template&id=0a60a6e8&scoped=true"
import script from "./index.vue?vue&type=script&lang=js"
export * from "./index.vue?vue&type=script&lang=js"
import style0 from "./index.vue?vue&type=style&index=0&id=0a60a6e8&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0a60a6e8",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/Users/nortonpigozzo/Development/nisoftwares/VeinsEnergia-api/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('0a60a6e8')) {
      api.createRecord('0a60a6e8', component.options)
    } else {
      api.reload('0a60a6e8', component.options)
    }
    module.hot.accept("./index.vue?vue&type=template&id=0a60a6e8&scoped=true", function () {
      api.rerender('0a60a6e8', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "assets/components/calculations/index.vue"
export default component.exports